
import {ConfirmDialogData} from "../interfaces/confirm-dialog-data";
import {ConfirmDialogComponent} from "./confirm-dialog.component";
import {DialogService} from "../services/dialog.service";

export function needConfirmation ( confirmData? : ConfirmDialogData) {

  return function (target: Object, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = async function (...args: any) {
      // Use inline default to avoid initialization order issues
      const dataToUse = confirmData ?? {
        title: "Confirmation",
        message: "Are you sure you want to perform this action?"
      };

      DialogService.getInstance()?.openDialog(dataToUse, ConfirmDialogComponent).subscribe((validation) => {
        if (validation){
          originalMethod.apply(this, args);
        }
      });
    };

    return descriptor;
  };


}
